import styled from "styled-components";
import Text from "../Text";
import {Sizes} from "../Styles";

/**
 * @author jaeho.lee104 on 2023. 08. 08..
 */
const NewH3 = styled(Text)`
  text-align: ${({textAlign}) => textAlign || "center"};
  font-feature-settings: 'clig' off, 'liga';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 133%;
  @media screen and ${Sizes.MEDIA_QUERY_MOBILE} {
    font-size: 24px;
  }
`;

export default NewH3;